import { useQuery } from '@tanstack/react-query';
import api from 'api';
import { SaleOrder } from 'models/SaleOrder';
import { useEffect, useState } from 'react';
import utils from 'utils';

export default (id: string) => {
  const [saleOrder, setSaleOrder] = useState<SaleOrder>();

  const {
    isLoading,
    error,
    data: queryData,
  } = useQuery({
    queryKey: ['saleOrder', id],
    cacheTime: utils.minutesInMiliseconds(15),
    staleTime: utils.minutesInMiliseconds(15),
    queryFn: () => api.saleOrders.getOrderById(id),
  });

  useEffect(() => {
    setSaleOrder(queryData?.data);
  }, [queryData, saleOrder]);

  return {
    saleOrder,
    isLoading,
    error,
  };
};
